import { FingerPrintIcon, UserPlusIcon } from "@heroicons/react/24/solid";
import React from "react";
import { NavLink } from "react-router-dom";

const AdminMenu = () => {
  return (
    <>
      <div className="menu-section border-b border-gray-700 ">
        <h2 className="text-lg text-white font-semibold font-mono mt-5 mb-3">Service</h2>
        <NavLink
          to="add-service"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 transition-colors font-mono duration-300 transform rounded hover:bg-gray-300 hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">Add Service</span>
        </NavLink>
        <NavLink
          to="all-service"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 mt-2 transition-colors font-mono duration-300 transform rounded hover:bg-gray-300 hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">All Services</span>
        </NavLink>
      </div>
      {/* Column Section */}
      <div className="border-b border-gray-700">
        <h2 className="text-lg text-white font-semibold font-mono mt-5 mb-3">Column</h2>
        <NavLink
          to="add-news"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 mt-2 transition-colors font-mono duration-300 transform rounded hover:bg-gray-300 hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">Add Columns</span>
        </NavLink>
        <NavLink
          to="all-news"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 mt-2 transition-colors font-mono duration-300 transform rounded hover:bg-gray-300 hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">All Column</span>
        </NavLink>
      </div>
      {/* News Section */}
      <div className="border-b border-gray-700">
        <h2 className="text-lg text-white font-semibold font-mono mt-5 mb-3">News</h2>
        <NavLink
          to="add-gallery"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 mt-2 transition-colors font-mono duration-300 transform rounded hover:bg-gray-300 hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">Add News</span>
        </NavLink>
        <NavLink
          to="all-gallery"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 mt-2 transition-colors font-mono duration-300 transform rounded hover:bg-gray-300 hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">All News</span>
        </NavLink>
      </div>

      {/* Consultation Section */}
      <div className="border-b border-gray-700">
        <h2 className="text-lg text-white font-semibold font-mono mt-5 mb-3">Consultation</h2>
        <NavLink
          to="quotation-req"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 mt-2 transition-colors font-mono duration-300 transform rounded hover:bg-gray-300 hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">Quotation Request</span>
        </NavLink>
        <NavLink
          to="consultation-req"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 mt-2 transition-colors font-mono duration-300 transform rounded hover:bg-gray-300 hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">Consultation Request</span>
        </NavLink>
      </div>

      {/* Jobs Section */}
      <div className="border-b border-gray-700">
        <h2 className="text-lg text-white font-semibold font-mono mt-5 mb-3">Jobs</h2>
        <NavLink
          to="add-jobs"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 mt-5  transition-colors font-mono duration-300 transform rounded   hover:bg-gray-300   hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">Add Jobs</span>
        </NavLink>
        <NavLink
          to="all-jobs"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 mt-5  transition-colors font-mono duration-300 transform rounded   hover:bg-gray-300   hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">All Jobs</span>
        </NavLink>
      </div>
      {/* Team */}
      <div className="border-b border-gray-700">
        <h2 className="text-lg text-white font-semibold font-mono mt-5 mb-3">Team</h2>
        <NavLink
          to="add-team"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 mt-5  transition-colors font-mono duration-300 transform rounded   hover:bg-gray-300   hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">Add Team Member</span>
        </NavLink>
        <NavLink
          to="all-team"
          className={({ isActive }) =>
            `flex items-center px-4 py-2 mt-5  transition-colors font-mono duration-300 transform rounded   hover:bg-gray-300   hover:text-gray-900 ${
              isActive
                ? "bg-white text-black"
                : "text-white"
            }`
          }
        >
          <span className="mx-4 font-medium">All Team Members</span>
        </NavLink>
      </div>
    </>
  );
};

export default AdminMenu;
